// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1PjQ5","inputWrap":"CustomTip_inputWrap__2dSXT"};